module.exports = __webpack_public_path__ + "img/ics_f_info_circle_yellow.d2a1b49d.svg";